import { Button, Flex, Form, Input, message, Select } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import UserRemoveModal from "./UserRemoveModal";
import { roleandpermissions } from "../../services";
import { CloseButton, options, showCustomMessage } from "./constant";
import { AppModal } from "../../components/common";

type Props = {
  addEditModal: boolean;
  singleData: any;
  setSingleData: (singleData: any) => void;
  setAddEditModal: (addEditModal: boolean) => void;
  refreshData: () => void;
};

export default function AddEditModal({
  addEditModal,
  setAddEditModal,
  singleData,
  setSingleData,
  refreshData,
}: Props): JSX.Element {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [addEditForm] = Form.useForm();

  const footer = (
    <>
      {singleData?._id && (
        <Button
          onClick={() => {
            setOpenModal(true);
            setAddEditModal(false);
          }}
        >
          Remove User
        </Button>
      )}
      <Button
        type="primary"
        loading={loader}
        onClick={() => addEditForm.submit()}
      >
        {singleData?._id ? "Save Changes" : "Invite"}
      </Button>
    </>
  );

  const addUser = (values: any) => {
    setLoader(true);
    const payload = {
      full_name: values.name,
      email: values.email,
      username: values.email,
      company: "SoulSara",
      phone_number: "9849420942",
      user_type: values.role,
    };
    if (singleData?._id) {
      roleandpermissions
        .editUserRoles(singleData?._id, payload)
        .then((res: any) => {
          showCustomMessage("Edited");
          setLoader(false);
          refreshData();
          setAddEditModal(false);
        })
        .catch((err: any) => {
          setLoader(false);
          message.error(err.message || "Something went wrong");
        });
    } else {
      roleandpermissions
        .addUserRoles(payload)
        .then((res: any) => {
          showCustomMessage("Added");
          refreshData();
          setLoader(false);
          setAddEditModal(false);
        })
        .catch((err: any) => {
          setLoader(false);
          message.error(err.message || "Something went wrong");
        });
    }
    addEditForm.resetFields();
  };

  useEffect(() => {
    if (singleData?._id) {
      addEditForm.setFieldsValue({
        name: singleData?.full_name,
        email: singleData?.email,
        role: singleData?.user_type,
      });
    }
  }, [singleData]);

  return (
    <Fragment>
      <AppModal
        onCancel={() => {
          setAddEditModal(false);
          setSingleData({});
          addEditForm.resetFields();
        }}
        title={singleData?._id ? "Update User Role" : "Add User"}
        open={addEditModal}
        footer={footer}
      >
        <Form
          form={addEditForm}
          onFinish={addUser}
          requiredMark={false}
          layout="vertical"
          name="userForm"
        >
          <Flex vertical gap={16}>
            <Form.Item
              className="roleSelect"
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Please enter the invitee's name" },
              ]}
            >
              <Input placeholder="Please enter the invitee's name" />
            </Form.Item>
            <Form.Item
              className="roleSelect"
              label="Email ID"
              name="email"
              rules={[
                { required: true, message: "Please enter the invitee's email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Please enter the invitee's email" />
            </Form.Item>
            <Form.Item
              className="roleSelect"
              label="Role"
              name="role"
              rules={[
                { required: true, message: "Please enter the invitee's role" },
              ]}
            >
              <Select
                options={options}
                className="role_select"
                suffixIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path fill="#2E3191" d="m7 10l5 5l5-5z" />
                  </svg>
                }
                placeholder="Please enter the invitee's role"
              />
            </Form.Item>
          </Flex>
        </Form>
      </AppModal>
      <UserRemoveModal
        refreshData={refreshData}
        singleData={singleData}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </Fragment>
  );
}
